import { LitElement, html } from 'lit';

import '../../../../neb-lit-components/src/components/neb-date-time-page';
import { parseDate } from '../../../../neb-utils/date-util';

export const ELEMENTS = {
  datePage: { id: 'date-page' },
};

class NebBookingDatePage extends LitElement {
  static get properties() {
    return {
      appointment: Object,
      layout: String,
    };
  }

  constructor() {
    super();

    this.__initState();
    this.__initHandlers();
  }

  __initState() {
    this.appointment = {};
    this.layout = '';

    this.onFormCompleted = () => {};
  }

  __initHandlers() {
    this.__handlers = {
      formCompleted: data => {
        const hours = Math.floor(data.time);
        const minutes = Math.round((data.time % 1) * 60);
        this.onFormCompleted({
          ...data,
          start: parseDate(data.date)
            .hours(hours)
            .minutes(minutes)
            .toISOString(),
        });
      },
    };
  }

  render() {
    return html`
      <neb-date-time-page
        id="${ELEMENTS.datePage.id}"
        .layout="${this.layout}"
        .appointment="${this.appointment}"
        .onFormCompleted="${this.__handlers.formCompleted}"
      ></neb-date-time-page>
    `;
  }
}

customElements.define('neb-booking-date-page', NebBookingDatePage);
